import type { TAnswers } from 'models/common.model'

export const getImplicitBehaviorIssuesK9 = (
  savedAnswers: Partial<TAnswers> | null | undefined,
): string[] => {
  if (!savedAnswers) return []

  const leashRaw = savedAnswers.leash_pulling_k9
  const leash = Array.isArray(leashRaw) ? leashRaw[0] : leashRaw

  return [
    ...(leash === 'yes' || leash === 'sometimes' ? ['leash_pulling'] : []),
  ]
}
